//TextField
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
        Typography
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const styles = (theme) => ({
        textField: {
                // backgroundColor: '#F3F3F3 !important',
                width: '100%',
                marginBottom: '5px'
        },
        label: {
                fontSize: '16px',
                fontWeight: 600
        },
        input: {
                //padding: '5px 14px !important',
                fontSize: '16px',
                fontWeight: 500,
                borderRadius: 5,
                marginBottom: 0,
                padding: '10.5px 14px',
        },
        labelColor: {
                color: 'gray'
        }
});

class MyTextField extends Component {
        constructor(props) {
                super(props)
                this.state = {
                        showPassword: false,
                }
        }

        togglePassword = () => {
                this.setState({
                        showPassword: !this.state.showPassword
                })
        }

        render() {
                const { classes } = this.props;

                return (
                        <div>
                                {this.props.label ?
                                        <Typography
                                                gutterBottom
                                                className={classes.label}
                                        >
                                                {this.props.label}
                                        </Typography> : ""}
                                <FormControl
                                        className={classes.textField}
                                        variant="outlined"
                                >
                                        <OutlinedInput
                                                placeholder={this.props.placeholder}
                                                type={this.state.showPassword ? 'text' : 'password'}
                                                name={this.props.name}
                                                onChange={this.props.onChange}
                                                onFocus={this.props.onFocus}
                                                value={this.props.value}
                                                inputlabelprops={{ classes: { root: classes.labelColor } }}
                                                inputProps={{
                                                        className: classes.input
                                                }}
                                                // endAdornment={
                                                //         <InputAdornment position="end">
                                                //                 <IconButton
                                                //                         onClick={this.togglePassword}
                                                //                         onMouseDown={this.togglePassword}
                                                //                         edge="end"
                                                //                 >
                                                //                         {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                                //                 </IconButton>
                                                //         </InputAdornment>
                                                // }
                                        />
                                        {this.props.error ?
                                                <FormHelperText
                                                        style={{ color: "red" }}
                                                >
                                                        {this.props.helperText}
                                                </FormHelperText> : ""}
                                </FormControl>
                        </div >
                )
        }
}

export default withStyles(styles)(MyTextField);